import { useState, useEffect } from "react";
import {
  Combobox,
  ComboboxButton,
  ComboboxInput,
  ComboboxOption,
  ComboboxOptions,
  Label,
} from "@headlessui/react";
import { CheckIcon, ChevronUpDownIcon } from "@heroicons/react/20/solid";

const SelectMenu = ({ label, data, defaultSelected, onSelect }) => {
  const [selected, setSelected] = useState(defaultSelected);
  const [query, setQuery] = useState("");

  const onSelectHandler = (item) => {
    if (!item) return;
    setSelected(item);
    setQuery("");
    onSelect(item);
  };

  useEffect(() => {
    if (defaultSelected && selected && defaultSelected.id !== selected.id) {
      setSelected(defaultSelected);
      setQuery("");
    }
  }, [defaultSelected, selected]);

  const filteredData =
    query === ""
      ? data
      : data.filter((item) => {
          const q = query.toLowerCase();
          return (
            item.name.toLowerCase().includes(q) ||
            item.id.toLowerCase().includes(q)
          );
        });

  return (
    <Combobox value={selected} onChange={onSelectHandler}>
      <Label className="block text-sm/6 font-medium text-ink-700">
        {label}
      </Label>
      <div className="relative mt-2">
        <div className="relative w-full">
          <ComboboxInput
            className="w-full rounded-card bg-white py-2 pl-3 pr-10 text-left text-ink-900 border border-ink-200 focus:border-accent-500 focus:ring-2 focus:ring-accent-500/20 focus:outline-none text-base sm:text-sm/6"
            displayValue={(item) => item?.name || ""}
            onChange={(e) => setQuery(e.target.value)}
            placeholder="Search..."
          />
          <ComboboxButton className="absolute inset-y-0 right-0 flex items-center pr-2">
            <ChevronUpDownIcon className="size-4 text-ink-400" />
          </ComboboxButton>
        </div>

        <ComboboxOptions
          transition
          className="absolute z-10 mt-2 max-h-60 w-full overflow-auto rounded-card bg-cream-50 py-1 text-base shadow-lift ring-1 ring-ink-200 focus:outline-none data-[closed]:data-[leave]:opacity-0 data-[leave]:transition data-[leave]:duration-150 data-[leave]:ease-editorial sm:text-sm"
        >
          {filteredData.length === 0 ? (
            <div className="relative cursor-default select-none py-2 px-4 text-ink-500">
              No results found.
            </div>
          ) : (
            filteredData.map((item) => (
              <ComboboxOption
                key={item.id}
                value={item}
                className="group relative cursor-default select-none py-2 pl-3 pr-9 text-ink-900 data-[focus]:bg-accent-500 data-[focus]:text-cream-50 data-[focus]:outline-none transition-colors"
              >
                <span className="block truncate font-normal group-data-[selected]:font-semibold">
                  {item.name}
                </span>

                <span className="absolute inset-y-0 right-0 flex items-center pr-4 text-accent-500 group-[&:not([data-selected])]:hidden group-data-[focus]:text-cream-50">
                  <CheckIcon className="size-4" />
                </span>
              </ComboboxOption>
            ))
          )}
        </ComboboxOptions>
      </div>
    </Combobox>
  );
};

export default SelectMenu;
